"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ isCommission }) {
    const notionLink = isCommission
        ? 'https://fondee.notion.site/8da02bb7af6b4bef8fd7d4ec08716c8d'
        : 'https://fondee.notion.site/56426f4935304dc1897c348af5e85ad8';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ component: "a", href: notionLink, target: "_blank", rel: "noopener noreferrer", sx: {
            width: '100%',
            height: '40px',
            p: '0 14px',
            borderRadius: '8px',
            border: '1px solid var(--gray-10)',
            color: 'var(--gray-80)',
            bgcolor: 'var(--white) !important',
        } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('가이드 보러가기') })) })));
}
exports.default = default_1;
